import { Children, isValidElement, type ReactNode } from 'react'

export const extractElementText = (children: ReactNode): string =>
	children
		? Children.toArray(children)
				.map((child): string => {
					if (child && isValidElement(child)) {
						return extractElementText(child.props.children as ReactNode)
					}
					if (typeof child === 'string') {
						return child
					}
					if (typeof child === 'number') {
						return String(child)
					}
					return ''
				})
				.join('')
		: ''
